<template>
    <div class="navbar-vertical-content">
        <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">

           <DashboardNavbar />
            <DossierNavbar />
            <!-- <CanauxNavbar /> -->
            <AdministrationNavbar />
        </div>
    </div>

</template>

<script>
import AdministrationNavbar from './navbars/AdministrationNavbar.vue';
import DossierNavbar from './navbars/DossierNavbar.vue';
// import IANavbar from './navbars/IANavbar.vue';
import DashboardNavbar from './navbars/DashboardNavbar.vue';
// import CanauxNavbar from './navbars/CanauxNavbar.vue';

export default {
    name:"NavbarAdmin",
    components:{
        DashboardNavbar,
        AdministrationNavbar,
        DossierNavbar,
        // IANavbar,
        // CanauxNavbar
    }
}

</script>